import { put, takeLatest, fork, select } from 'redux-saga/effects'
import { createApiCall } from 'services/api'
import { ActionType } from './model'
import { ActionType as CommonActionType } from '../common/model'
import { Action, ActionCallback } from '../model'

export function* getAgencySaga(): Generator {
  yield takeLatest(ActionType.GET_AGENCY, function* () {
    try {
      const {
        auth: { user },
      } = yield select()

      if (user.agencyId) {
        const { data, status } = yield createApiCall({
          url: `/agency/${user.agencyId}`,
        })

        yield put({
          type: ActionType.SET_AGENCY,
          payload: status === 200 ? data : null,
        })
      }
    } catch (error) {
      // error
    }
  })
}

export function* patchAgencySaga(): Generator {
  yield takeLatest(ActionType.PATCH_AGENCY, function* (action: ActionCallback) {
    try {
      const { payload, callback } = action
      const {
        auth: { user },
      } = yield select()

      if (user.agencyId) {
        const { status } = yield createApiCall({
          method: 'PATCH',
          url: `/agency/${user.agencyId}`,
          data: payload,
        })

        if (status === 200) {
          yield put({
            type: ActionType.GET_AGENCY,
          })
          yield put({
            type: CommonActionType.SET_NOTIFICATION,
            payload: {
              status: 'success',
              message: 'Изменения сохранены',
            },
          })
        }
        callback({ success: status === 200 })
      }
    } catch (error) {
      // error
    }
  })
}

export function* getClientCompanySaga(): Generator {
  yield takeLatest(ActionType.GET_CLIENT_COMPANY, function* (action: Action<{ clientCompanyId: number }>) {
    try {
      const { payload } = action
      const { data, status } = yield createApiCall({
        url: `/clients/${payload.clientCompanyId}`,
      })

      yield put({
        type: ActionType.SET_CLIENT_COMPANY,
        payload: status === 200 ? data : null,
      })
    } catch (error) {
      // error
    }
  })
}

export default [fork(getAgencySaga), fork(patchAgencySaga), fork(getClientCompanySaga)]
